import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import styled from 'styled-components';
import useAuth from '../../../../features/hooks/useAuth';
import { useGetUsersQuery, useModifyArrayUserMutation } from '../../../../features/users/usersApiSlice';
import { useUpdateassetReqMutation } from '../../../../features/assetrequest/assetReqApiSlice';
import { useUpdateMultipleDocsMutation } from '../../../../features/addassets/addassetfinalApiSlice';
import { CommonButton } from '../../../../Styles/CommonStyles';
import nameStringFn from '../../../../data/nameStringFn';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CircularProgress from '@mui/material/CircularProgress';
import FilteredAssetsFetcher from '../../Myasset/FilteredAssetsFetcher';
import { useGetofficesQuery, useUpdateofficeMutation } from '../../../../features/offices/officesApiSlice';
import { useAddNewTransactionMutation } from '../../../../features/transactions/transactionsApiSlice';

const Container = styled.div`
  margin-right: 10px;
  padding: 10px;
`;

const ButtonCont = styled.div`
  display: flex;
  margin-top: 10px;
  margin-bottom: 20px;
  gap: 5px;
`;

const AcceptButton = styled(CommonButton)`
  background-color: #4caf50;
  
  &:hover {
    background-color: #45a049;
  }
`;

const RejectButton = styled(CommonButton)`
  background-color: #f44336;
  
  &:hover {
    background-color: #d32f2f;
  }
`;
const RemarkContainer = styled.div`
  margin-top: 15px;
  width: 100%;
`;

const Bo_UserTransferInboxForm = ({ row, showActionOptions, handleBack }) => {  
  const [remark, setRemark] = useState('');
  const [assetDetails, setAssetDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const editor = useRef(null);
  const navigate = useNavigate();
  const { id: reqId } = useParams();
console.log("row", row)
  const { getSingleuser } = useGetUsersQuery('userslist', {
    selectFromResult: ({ data }) => ({
      getSingleuser: data?.entities
    }),
  });

  const { officedata } = useGetofficesQuery('offices', {
    selectFromResult: ({ data }) => ({
      officedata: data?.entities
    }),
  });
  
  
  // Get logged in user data

  const { id, email, designation, designationSuffix, numSuffix, roles } = useAuth();
  const user_current_office = useSelector((state) => state.office.off);
  const BO_id = officedata ? Object.values(officedata)?.find(office => office?.name === user_current_office)?.Bo : "";

  
  // API mutations
  const [updateReq] = useUpdateassetReqMutation();
  const [addTrans] = useAddNewTransactionMutation();
  const [modifyArrayUser] = useModifyArrayUserMutation();
  const [updateMultipleAssetDocs] = useUpdateMultipleDocsMutation();
  const [updateOffice] = useUpdateofficeMutation();

  // Handler to update asset details when fetched by FilteredAssetsFetcher
  const handleAssetsFetched = (data) => {
    if (data?.assets && data.assets.length > 0) {
      const detailsMap = {};
      data.assets.forEach(asset => { 
        detailsMap[asset._id] = asset; 
      });
      setAssetDetails(detailsMap);
    }
    setLoading(false);
  };
  
  // Handle accepting the asset transfer
  const handleAccept = async () => {
    if (!remark.trim()) {
      alert("Please provide a remark");
      return;
    }
    
    if (!row) {
      alert("Request data not found");
      return;
    }
    
    try {
      setProcessing(true);
      
      // Get asset IDs from the last request object
      const assetIds = row.assets_requested?.[row.assets_requested.length - 1]?.data.map( x => x.id) || [];
      
      if (assetIds.length === 0) {
        setProcessing(false);
        return alert("No assets found in this request");
      }

      const transacData = {
        transac_id: row?.uniqueReqId,
        req_id: "",
        asset_id: assetIds,
        transac_type: 'BoToUserHandover',
        indi_asset: false, // Additional field to indicate if it's an individual asset
        from_userid: getSingleuser?.[BO_id]?.email,
        from_office: user_current_office,
        from_desig: getSingleuser?.[BO_id]?.designation?.[user_current_office],
        from_store: row?.req_store,
        to_userid: email,
        to_office: user_current_office,
        to_desig: designation?.[user_current_office],
        to_store: row?.req_store,
        pdfPath: "",
        time_stamp: new Date().toISOString()
      };
      
      // Create request data for the acceptance action
      const senttoData = {
        sent_to_tag: "botouser_transfer_accepted",
        action: 'Asset Transfer Request from BO Accepted by User',
        Text: remark,
        sent_by: { 
          id, 
          name: getSingleuser?.[id]?.name || 'User', 
          office: user_current_office, 
          designation: designation[user_current_office], 
          designationSuffix: designationSuffix[user_current_office], 
          numSuffix: numSuffix[user_current_office] 
        },
        sent_to: { 
          id: id,
          name: getSingleuser?.[id]?.name || 'User', 
          office: user_current_office, 
          designation: designation[user_current_office], 
        },
        curr_sent_to_string: `${nameStringFn(getSingleuser?.[id])}-${user_current_office}-${designation[user_current_office] || 'Unknown'}`,
        curr_status: "Closed",
        time_stamp: new Date()
      };

      const assetBody = {
        assetIdArray: assetIds,
        updates: {
          cur_loc: "office",
          last_trans_date: new Date().toISOString(),
          alloc_user: id,
          cur_user_name: `${getSingleuser?.[id]?.email} (${nameStringFn(getSingleuser?.[id])})`
        }
      }      
      const body = { id: row?._id, senttoData: senttoData };

      // Prepare bulk user role updates
      const userRoleModifications = {
        modifications: [
          // 1. Remove BO role from current BO user
          {
            _id: BO_id,
            operation: "remove",
            arrayField: `roles.${user_current_office}`,
            elements: ["Bo"]
          },
          // 2. Add BO role to accepting user
          {
            _id: id,
            operation: "add",
            arrayField: `roles.${user_current_office}`,
            elements: ["Bo"]
          }
        ]
      };

      // 3. Update office document to change Bo field to new user
      const currentOfficeDoc = Object.values(officedata).find(office => office?.name === user_current_office);
      const updateOfficeBoId = {
        id: currentOfficeDoc?._id,
        Bo: id
      };

      const res = await updateReq(body);
      const res2 = await updateMultipleAssetDocs(assetBody);
      const res3 = await addTrans(transacData);
      
      // Update both users' roles in single API call
      const res4 = await modifyArrayUser(userRoleModifications);
      
      // Update office Bo field
      const res5 = await updateOffice(updateOfficeBoId);

      setProcessing(false);
      handleBack();
      alert('BO Assets and Role transfer completed successfully! You are now the Branch Officer.');
    } catch (error) {
      setProcessing(false);
      console.error("Error accepting transfer:", error);
      alert(`Error: ${error.message || 'Failed to accept transfer'}`);
    }
  };
  
  // Handle rejecting the asset transfer
  const handleReject = async () => {
    if (!remark.trim()) {
      alert("Please provide a reason for rejection");
      return;
    }
    
    if (!row) {
      alert("Request data not found");
      return;
    }
    
    try {
      setProcessing(true);
      
      // Create request data for the rejection action
      const senttoData = {
        sent_to_tag: "botouser_transfer_rejected",
        action: 'Asset Transfer Request from BO Rejected by User',
        Text: remark,
        sent_by: { 
          id, 
          name: getSingleuser?.[id]?.name || 'User', 
          office: user_current_office, 
          designation: designation[user_current_office], 
          designationSuffix: designationSuffix[user_current_office], 
          numSuffix: numSuffix[user_current_office] 
        },
        sent_to: { 
          id: row.req_creator_id,
          name: getSingleuser?.[row.req_creator_id]?.name || 'Branch Officer',
          office: user_current_office,
          designation: getSingleuser?.[row.req_creator_id]?.designation?.[user_current_office] || 'BO'
        },
        curr_sent_to_string: `${nameStringFn(getSingleuser?.[row.req_creator_id])}-${user_current_office}-${getSingleuser?.[row.req_creator_id]?.designation?.[user_current_office] || 'Unknown'}`,
        curr_status: "Rejected",
        time_stamp: new Date()
      };

      const body = { id: row?._id, senttoData: senttoData };

      const res = await updateReq(body);

      setProcessing(false);
      handleBack();
      alert('Asset transfer request rejected');
    } catch (error) {
      setProcessing(false);
      console.error("Error rejecting transfer:", error);
      alert(`Error: ${error.message || 'Failed to reject transfer'}`);
    }
  };
  console.log(showActionOptions)
  // Get the asset IDs from the request to use in fetching asset details
  const getAssetIdsForFilter = () => {
    if (!row || !row.assets_requested || row.assets_requested.length === 0) return [];
    const lastRequestObject = row.assets_requested[row.assets_requested.length - 1];
    return lastRequestObject?.data || [];
  };
  
  return (
    <Container>
      {/* Use FilteredAssetsFetcher to get asset details */}
      {row && <FilteredAssetsFetcher 
        filters={{ ids: getAssetIdsForFilter() }} 
        onDataFetched={handleAssetsFetched} 
      />}

      {showActionOptions ? <><RemarkContainer>
        <TextField
          fullWidth
          multiline
          rows={4}
          label="Add Remark"
          variant="outlined"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
        />
      </RemarkContainer>     
      
      <ButtonCont>
        <AcceptButton 
          onClick={handleAccept} 
          startIcon={processing ? <CircularProgress size={20} color="inherit" /> : <CheckCircleIcon />}
          disabled={processing || loading}
        >
          {processing ? 'Processing...' : 'Accept BO Assets and Role'}
        </AcceptButton>
        <RejectButton 
          onClick={handleReject} 
          startIcon={processing ? <CircularProgress size={20} color="inherit" /> : <CancelIcon />}
          disabled={processing || loading}
        >
          {processing ? 'Processing...' : 'Reject Transfer'}
        </RejectButton>
      </ButtonCont></>:null}
    </Container>
  );
};

export default Bo_UserTransferInboxForm; 